import { NeoModel, Attributes, ModelBase } from '@singularsystems/neo-core';
@NeoModel
export default class CashHoldingLookup extends ModelBase {

    public clientAccount: string = "";

    public rawAccountNumber: string = "";

    @Attributes.Date()
    public reportDate: Date | null = null;

    public currency: string = "";

    public balance: number | null = null;

    public balanceUSD: number | null = null;
}